/**
 * Word Factory Autofill
 * Auto-fills Teeinblue personalization fields with Word Factory data
 */

document.addEventListener('DOMContentLoaded', () => {
  // Try to fetch the saved values from localStorage
  const word = localStorage.getItem('nwf_word');
  const definition = localStorage.getItem('nwf_definition');
  const pronunciation = localStorage.getItem('nwf_pronunciation');

  if (!word && !definition && !pronunciation) {
    console.log('💬 No Word Factory data found');
    return; // nothing to do
  }

  console.log('💬 Word Factory data found, waiting for Teeinblue form...');

  // Wait for Teeinblue form to render
  const teeInterval = setInterval(() => {
    const wordInput = document.querySelector('.nfw-title .tee-field__input input');
    const pronInput = document.querySelector('.nfw-pronunciation .tee-field__input input');
    const defTextarea = document.querySelector('.nfw-definition .tee-field__input textarea');

    if (wordInput || pronInput || defTextarea) {
      console.log('✅ Teeinblue form found, auto-filling...');

      if (wordInput && word) {
        wordInput.value = word;
        wordInput.dispatchEvent(new Event('input', { bubbles: true }));
        console.log('  ↳ Word:', word);
      }

      if (pronInput && pronunciation) {
        pronInput.value = pronunciation;
        pronInput.dispatchEvent(new Event('input', { bubbles: true }));
        console.log('  ↳ Pronunciation:', pronunciation);
      }

      if (defTextarea && definition) {
        defTextarea.value = definition;
        defTextarea.dispatchEvent(new Event('input', { bubbles: true }));
        console.log('  ↳ Definition:', definition);
      }

      clearInterval(teeInterval);
    }
  }, 500); // check twice a second until loaded

  // Stop checking after 10 seconds
  setTimeout(() => {
    clearInterval(teeInterval);
    console.log('⏱️ Stopped checking for Teeinblue form');
  }, 10000);
});
